import { Layout, ThreadList, Thread, BuySell } from '@/views/tracker';

export default {
    path: '/tracker',
    component: Layout,
    children: [
        { path: 'list', component: ThreadList },
        { path: 'thread', name: "thread", component: Thread },
        { path: 'buy-sell', component: BuySell },
    ]
};
